/*
 * Copyright (c) Worldline 2023.
 */

/**
 * End user web services
 * Endpoints of end user web services
 *
 * The version of the OpenAPI document: 2.2.3-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import {SignerDto} from './signerDto';
import {DocumentDto} from './documentDto';


/**
 * This Dto gives information about a signature.
 */
export interface SignatureDto {
    /**
     * Action (Signature, Approval)
     */
    action?: SignatureDto.ActionEnum;
    /**
     * Agreement Method.
     */
    agreementMethod?: SignatureDto.AgreementMethodEnum;
    /**
     * Accepted channels.
     */
    channels?: Array<SignatureDto.ChannelsEnum>;
    /**
     * Signature Date.
     */
    signatureDate?: string;
    signerDto?: SignerDto;
    documentDto?: DocumentDto;
    /**
     * External Signature Status.
     */
    externalSignatureStatus?: SignatureDto.ExternalSignatureStatusEnum;
    /**
     * Check if the document has been fully read
     */
    controlDocumentCompleteReading?: boolean;
}
export namespace SignatureDto {
    export type ActionEnum = 'SIGNATURE' | 'WATERMARK' | 'APPROVAL' | 'FINAL_AGREEMENT';
    export const ActionEnum = {
        Signature: 'SIGNATURE' as ActionEnum,
        Watermark: 'WATERMARK' as ActionEnum,
        Approval: 'APPROVAL' as ActionEnum,
        FinalAgreement: 'FINAL_AGREEMENT' as ActionEnum
    };
    export type AgreementMethodEnum = 'TABLET' | 'SMARTPHONE' | 'OTP' | 'CLICK';
    export const AgreementMethodEnum = {
        Tablet: 'TABLET' as AgreementMethodEnum,
        Smartphone: 'SMARTPHONE' as AgreementMethodEnum,
        Otp: 'OTP' as AgreementMethodEnum,
        Click: 'CLICK' as AgreementMethodEnum
    };
    export type ChannelsEnum = 'SMS' | 'EMAIL' | 'SMS_EMAIL';
    export const ChannelsEnum = {
        Sms: 'SMS' as ChannelsEnum,
        Email: 'EMAIL' as ChannelsEnum,
        SmsEmail: 'SMS_EMAIL' as ChannelsEnum
    };
    export type ExternalSignatureStatusEnum = 'INIT' | 'AGREED' | 'CONSENTED' | 'ERR_TECH' | 'ERR_BUSINESS' | 'SUCCESSFUL' | 'SUCCESSFUL_BY_GROUP';
    export const ExternalSignatureStatusEnum = {
        Init: 'INIT' as ExternalSignatureStatusEnum,
        Agreed: 'AGREED' as ExternalSignatureStatusEnum,
        Consented: 'CONSENTED' as ExternalSignatureStatusEnum,
        ErrTech: 'ERR_TECH' as ExternalSignatureStatusEnum,
        ErrBusiness: 'ERR_BUSINESS' as ExternalSignatureStatusEnum,
        Successful: 'SUCCESSFUL' as ExternalSignatureStatusEnum,
        SuccessfulByGroup: 'SUCCESSFUL_BY_GROUP' as ExternalSignatureStatusEnum
    };
}


